import { MstSignallampComponentType } from "../../../types/types";
import { translate } from "@/main";

/**
 * パトランプ設定情報入力値チェック処理。
 * @param { MstSignallampComponentType } MstSignallampComponentType チェック対象データ
 * @param userID
 * @param signallampID
 * @param deviceIds //スルー
 * @param selectDeviceId
 * @returns {string | boolean} チェック結果
 */
export function checkComponentSettingData(
  updateData: MstSignallampComponentType
): string | boolean {
  const checkUserIdResult = checkUserId(updateData.user_id);
  const checkLocationNameResult = updateData.component_title === "" ? {result: true, msg: ""} : checkSignalGraphTitle(updateData.component_title);
  const checkDeviceIdResult = updateData.select_device_id === "" ? {result: false, msg: `${translate("message.deviceIdCannotBeEmpty")}`} : checkDeviceId(updateData.select_device_id);
  if (!checkUserIdResult.result) {
    return checkUserIdResult.msg;
  }
  if (!checkLocationNameResult.result) {
    return checkLocationNameResult.msg;
  }
  if (!checkDeviceIdResult.result) {
    return checkDeviceIdResult.msg;
  }
  if (!updateData.signallamp_id) {
    return `${translate("message.componentIdDoesNotExist")}`;
  }
  return false;
}

function checkUserId(userID: string) {
  const cognitoUserId = JSON.parse(localStorage.getItem("iotKyotoAuth")).userName;
  if (userID !== cognitoUserId) {
    return {result: false, msg: `${translate("message.userIdIsInvalid")}`};
  }
  return {result: true, msg: ""};
}

function checkSignalGraphTitle(title: string) {
  const regex = /^[\w\W-_亜-熙ぁ-んァ-ヶ]*$/g;
  const count = /^[\w\W-_亜-熙ぁ-んァ-ヶ]{0,20}$/g;
  if (!title.match(regex)) {
    return {result: false, msg: `${translate("message.titleCannotHaveSymbolsExceptHyphensAndUnderscores")}`};
  }
  if (!title.match(count)) {
    return {result: false, msg: `${translate("message.titleCanHaveMaximumOf20Chars")}`};
  }
  return {result: true, msg: ""};
}

function checkDeviceId(deviceId: any) {
  const regex = /^[\w\W-_:\.]*$/g;
  const count = /^[\w\W-_:\.]{1,15}$/g;
  for (const key in deviceId) {
    if (!deviceId[key].match(regex)) {
      return {result: false, msg: `${translate("message.deviceIdCannotHaveSymbolsExceptHyphensUnderscoresAndColons")}`};
    }
    if (!deviceId[key].match(count)) {
      return {result: false, msg: `${translate("message.deviceIdCanHaveMaximumOf15Chars")}`};
    }
  }
  return {result: true, msg: ""};
}
